export const tktCorrectData = [
  "1957",
  "2068.12",
  "95164",
  "32.025",
  "4125.93",
  "7564.2",
  "60284",
  "16754.42",
  "89425.12",
  "30598",
  "1809.32+7895.43",
  "456.1*65647.23",
  "9851.01/654.32",
  "5456.98-6542.1",
  "2015.47*8754.07",
  "323.29/10.002",
  "8574.63+6125.88",
  "1203.19-206.36",
  "8146.62*5743.21",
  "9137.02/6041.57",
];

export const ttTypingPassage = `
  Acme Inc. today announced a third quarter operating profit of $45.0 million, as compared to a net 
  operating loss of $9.5 million for the second quarter of this year. The company also reported record revenue 
  of $247 million for the quarter. Eric Smith, CEO of Acme, explained: "We are pleased to report that our efforts
  to improve sales in our core business have been successful. Our primary revenue stream continues to be domestic
  sales of our transistor products, and we expect to see continued growth in this area over the next few quarters.
  Administrative expenses as a percent of net revenues for the third quarter were 27.0 percent compared to 32.5 percent
  for the second quarter, which continues to reflect our cost savings initiatives that we implemented starting in
  November of last year." Acme also announced a share buyback plan that allows the repurchase of up to $200 million
  of the company's outstanding common stock over the next 12 months.
`;
